export interface ShareDisclaimerProps {
  intro?: string;
  permissionNote?: string;
}

const DEFAULT_INTRO = 'Please review and confirm the following before proceeding:';
const DEFAULT_PERMISSION_NOTE = 'Please confirm that you have verified your permission to share this data.';

export function ShareDisclaimer({
  intro = DEFAULT_INTRO,
  permissionNote = DEFAULT_PERMISSION_NOTE,
}: ShareDisclaimerProps) {
  return (
    <>
      <div className="share-disclaimer-card">
        <p>{intro}</p>
        <ul>
          <li>
            The agent/prompt you are sharing may include Client Confidential Information (CCI),
            Firm Confidential Information (FCI), including third-party licensed content, and/or
            Personally Identifiable Information (PII). By selecting "Confirm and Share", you
            confirm that you have the necessary rights and/or permissions to share this content
            with these user(s).
          </li>
          <li>You confirm that you have the necessary rights and permissions to share this content.</li>
        </ul>
      </div>
      <p className="share-disclaimer-permission-note">{permissionNote}</p>
    </>
  );
}
